import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { roles: () => import('./RolesPage.vue') },
} satisfies FeatureRoutes
